import _ from 'lodash';

export const LOCATION_PERMISSIONS_KEY = 'location';
export const GENERIC_PERMISSIONS_KEY = 'generic';

export const VALID_ANY_TEAM_OWNER_PERMISSIONS = [
  'viewStaffMembersList',
  'viewAllTeams'
];

export const VALID_TEAM_OWNER_PERMISSIONS = [
  'inviteNewTeamMember',
  'inviteNewStaffMember',
  'editTeamDetails',
  'editTeamMembers',
  'removeTeamMembers',
  'addTeamMembers',
  'viewTeamDetails'
];

export const hasEntityPermission = ({
  userPermissions,
  permission,
  locationRef
}) => {
  if (!userPermissions) {
    throw Error(
      "User Permissions is 'undefined'. This is probably due to a race condition."
    );
  }

  if (locationRef) {
    return _.get(
      userPermissions[LOCATION_PERMISSIONS_KEY],
      `${locationRef}.${permission}`,
      false
    );
  }

  return _.get(userPermissions[GENERIC_PERMISSIONS_KEY], permission, false);
};

export const hasEntityPermissionOrTeamOwnership = ({
  userPermissions,
  permission,
  locationRef,
  teamId,
  userTeams
}) => {
  // We want to check for permissions only if user is not owner of the team, otherwise - return true
  if (!_.find(VALID_TEAM_OWNER_PERMISSIONS, perm => perm === permission)) {
    throw new Error(`${permission} is not a valid team owner permission`);
  }

  const teamInStore = _.find(userTeams, {id: teamId});
  const userIsOwner = _.get(teamInStore, 'isOwner', false);

  if (!userIsOwner) {
    return hasEntityPermission({
      userPermissions,
      permission,
      locationRef
    });
  }

  return true;
};

export const hasEntityPermissionOrAnyTeamOwnership = ({
  userPermissions,
  permission,
  locationRef,
  teamsThatIOwn
}) => {
  // We want to check for permissions only if user is owner of any team, otherwise - return true
  if (!_.find(VALID_ANY_TEAM_OWNER_PERMISSIONS, perm => perm === permission)) {
    throw new Error(`${permission} is not a valid any team owner permission`);
  }

  const userIsOwnerOfAnyTeam = !_.isEmpty(teamsThatIOwn);

  if (!userIsOwnerOfAnyTeam) {
    return hasEntityPermission({
      userPermissions,
      permission,
      locationRef
    });
  }

  return true;
};
